// Mouse parallax de la landing (shapes del hero).
// Inicializa la lib parallax.js (cargada vía CDN en application.html.erb) sobre
// el contenedor .js-parallax-scene. Antes este archivo se llamaba swiper.js e
// incluía un slider .book-table-img-slider que ya no existe en ninguna vista.
document.addEventListener("turbo:load", () => {
  const parallaxElement = document.querySelector(".js-parallax-scene")
  if (parallaxElement && typeof Parallax !== "undefined") {
    new Parallax(parallaxElement)
  }
})
